export const CSS_CLASS_BLOCK_NAME = 'bb-sport-event';

export const SELECTION_CSS_CLASS_ELEMENT_NAME = `${CSS_CLASS_BLOCK_NAME}__selection`;

export const HOME_COLUMN = '1';
export const DRAW_COLUMN = 'X';
export const AWAY_COLUMN = '2';

export const TWO_WAY_COLUMN_LENGTH = 2;
export const THREE_WAY_COLUMN_LENGTH = 3;

export const SELECTION_SUSPENDED_CLASS_NAME = `${SELECTION_CSS_CLASS_ELEMENT_NAME}--inactive`;
export const SELECTION_CSS_ID_ATTRIBUTE_NAME = 'data-selection-id';
export const SELECTION_CSS_LABEL_ATTRIBUTE_NAME = 'data-label';
export const SELECTION_CSS_CORRECTSCORE_ID_ATTRIBUTE_NAME = 'data-correctscore-id';
export const SELECTION_CSS_FIRSTGOALSCORER_ID_ATTRIBUTE_NAME = 'data-firstgoalscorer-id';
export const SELECTION_SHORTENING_CLASS_NAME = `${SELECTION_CSS_CLASS_ELEMENT_NAME}--shortening`;
export const SELECTION_LENGTHENING_CLASS_NAME = `${SELECTION_CSS_CLASS_ELEMENT_NAME}--lengthening`;
export const SELECTION_IN_BETSLIP_CLASS_NAME = `${SELECTION_CSS_CLASS_ELEMENT_NAME}--selected`;
export const SELECTION_HIGHLIGHT_DURATION_IN_MILLI_SECONDS = 1000;
export const SELECTION_HIDDEN_CLASS_NAME = `${SELECTION_CSS_CLASS_ELEMENT_NAME}--hide`;
export const SELECTION_SCORECAST_CLASS_NAME = 'scorecast';

export const I18N_PREFIX = 'mkt_headers';

export const SELECTION_GTM_ADD_BETSLIP = 'add-to-bet-slip';
export const SELECTION_GTM_REMOVE_BETSLIP = 'remove-from-bet-slip';
